var cbtUtil = require("../cbtUtil");

/**
 * @description It manages the dataLayer object that will be pushed as eePromoClick event.
 * @param {jQuery} $bannerElem - the clicked banner element
 * @param {Number} bannerPosition - the position of the containing banner
 * @return {Object} dataLayer object to be pushed
 */
function getBannerElemDataLayer ($bannerElem, bannerPosition) {
    var dataLayer = {
        "event": "eePromoClick",
        "promotions": []
    };

    var bannerElemCbt = $bannerElem.attr("data-cbt");
    var cbtData = cbtUtil.parseJSON(bannerElemCbt);

    cbtData.promotions[0].position = bannerPosition + 1;
    dataLayer.promotions.push(cbtData.promotions[0]);

    return dataLayer;
}

/**
 * @description It manages the dataLayer object that will be pushed as eePromoView.
 * @param {jQuery} $bannerList - array of banner elements
 * @return {Object} dataLayer object to be pushed
 */
function heroBannerListDataLayer ($bannerList) {
    var dataLayer = {
        "event": "eePromoView",
        "promotions": []
    };

    $bannerList.each(function(i, el) {
        var $banner = $(el);
        var $bannerImageCbt = $banner.find(".hero-banner-img-container a").attr("data-cbt");
        var $bannerCTACbt = $banner.find(".hero-banner-text-wrapper a").attr("data-cbt");

        var imageCbt = cbtUtil.parseJSON($bannerImageCbt);
        var CTACbt = cbtUtil.parseJSON($bannerCTACbt);

        if (imageCbt && imageCbt.promotions) {
            imageCbt.promotions[0].position = i;
            dataLayer.promotions.push(imageCbt.promotions[0]);
        }

        if (CTACbt && CTACbt.promotions) {
            CTACbt.promotions[0].position = i;
            dataLayer.promotions.push(CTACbt.promotions[0]);
        }
    });

    return dataLayer;
}

/**
 * Helper function to create the dataLayer and push it when
 * a Hero Banner image or CTA is clicked
 */
function cbtHeroBannerCtaClick () {
    var $bannerList = $(".hero-banner");
    if ($bannerList.length) {
        $bannerList.each(function(i, el) {
            var $banner = $(el);
            $banner.on("click", ".hero-banner-img-container a, .hero-banner-text-wrapper a", function() {
                var bannerData = getBannerElemDataLayer($(this), i);
                cbtUtil.dataPush(bannerData);
            });
        });
    }
}

/**
 * Helper function to create the dataLayer and push it when
 * a Hero Banner is shown
 */
function cbtHeroBannerShown () {
    var $bannerList = $(".hero-banner");
    if ($bannerList.length) {
        var bannerData = heroBannerListDataLayer($bannerList);
        cbtUtil.dataPush(bannerData);
    }
}

document.addEventListener("DOMContentLoaded", function() {
    cbtHeroBannerCtaClick();
    cbtHeroBannerShown();
});
